<script setup lang="ts">
    import { Sidebar, SidebarContent, SidebarGroup, SidebarGroupContent } from '@/shared/ui/Sidebar';

    import AppSidebarHeader from './AppSidebarHeader.vue';
    import AppSidebarMenu from './AppSidebarMenu.vue';
    import AppSidebarFooter from './AppSidebarFooter.vue';
</script>

<template>
    <Sidebar collapsible="icon">
        <AppSidebarHeader />
        <SidebarContent>
            <SidebarGroup>
                <SidebarGroupContent class="pt-[6px]">
                    <AppSidebarMenu />
                </SidebarGroupContent>
            </SidebarGroup>
        </SidebarContent>
        <AppSidebarFooter />
    </Sidebar>
</template>
